const isDev = import.meta.env.DEV;

function truncate(value: unknown, max = 500): unknown {
  try {
    if (value == null) return value;
    if (typeof value === 'string') {
      return value.length > max ? value.slice(0, max) + '…(truncated)' : value;
    }
    const str = JSON.stringify(value);
    return str.length > max ? str.slice(0, max) + '…(truncated)' : value;
  } catch {
    return '[unserializable]';
  }
}

// Use function expressions to avoid issues with vite-plugin-remove-console
const debugFn = (...args: unknown[]) => { 
  if (isDev) console.debug(...args.map((a) => truncate(a))); 
};

const infoFn = (...args: unknown[]) => { 
  if (isDev) console.info(...args.map((a) => truncate(a))); 
};

const warnFn = (...args: unknown[]) => {
  // eslint-disable-next-line no-console
  console.warn(...args.map((a) => truncate(a)));
};

const errorFn = (...args: unknown[]) => {
  // eslint-disable-next-line no-console
  console.error(...args.map((a) => truncate(a)));
};

export const logger = {
  debug: debugFn,
  info: infoFn,
  warn: warnFn,
  error: errorFn,
};

export default logger;


